"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorQuerySerializeSparql = void 0;
const bus_query_serialize_1 = require("@comunica/bus-query-serialize");
const core_1 = require("@comunica/core");
const algebra_sparql_1_2_1 = require("@traqula/algebra-sparql-1-2");
const core_2 = require("@traqula/core");
const generator_sparql_1_2_1 = require("@traqula/generator-sparql-1-2");
/**
 * A comunica SPARQL Query Serialize Actor.
 */
class ActorQuerySerializeSparql extends bus_query_serialize_1.ActorQuerySerialize {
    constructor(args) {
        super(args);
    }
    async test(action) {
        if (action.queryFormat.language !== 'sparql') {
            return (0, core_1.failTest)('This actor can only serialize SPARQL queries');
        }
        return (0, core_1.passTestVoid)();
    }
    async run(action) {
        const generator = new generator_sparql_1_2_1.Generator({
            [core_2.traqulaIndentation]: action.newlines === false ? -1 : 0,
            indentInc: action.indentWidth ?? 2,
        });
        // This query source only handles the Known Algebra from @comunica/utils-algebra.
        // It will likely throw when unknown algebra operations are being translated
        // or the translation will not happen correctly.
        const ast = (0, algebra_sparql_1_2_1.toAst)(action.operation);
        const query = generator.generate(ast).trim();
        return { query };
    }
}
exports.ActorQuerySerializeSparql = ActorQuerySerializeSparql;
//# sourceMappingURL=ActorQuerySerializeSparql.js.map